"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faInboxOut = void 0;
const faInboxOut = {
  prefix: 'fal',
  iconName: 'faInboxOut',
  icon: [512, 512, [], '', 'M155.3 139.3L240 54.63V304C240 312.8 247.2 320 256 320s16-7.156 16-16V54.63l84.69 84.69c6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62l-112-112C264.2 1.562 260.1 0 256 0S247.8 1.562 244.7 4.688l-112 112c-6.25 6.25-6.25 16.38 0 22.62S149.1 145.6 155.3 139.3zM464 320h-80c-6.061 0-11.6 3.424-14.31 8.844L342.1 384H169.9l-27.58-55.15C139.6 323.4 134.1 320 128 320H48C21.49 320 0 341.5 0 368v96C0 490.5 21.49 512 48 512h416c26.51 0 48-21.49 48-48v-96C512 341.5 490.5 320 464 320zM480 464c0 8.836-7.162 16-16 16h-416C39.16 480 32 472.8 32 464v-96C32 359.2 39.16 352 48 352h70.11l27.58 55.16C148.4 412.6 153.9 416 159.1 416H352c6.062 0 11.6-3.424 14.31-8.846L393.9 352H464c8.838 0 16 7.164 16 16V464z']
};
exports.faInboxOut = faInboxOut;